export default "__VITE_ASSET__CSpX3jAd__"